import _ from 'lodash'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withCookies, Cookies } from 'react-cookie'
import cx from 'classnames'
import Input from '../Input/Input'
import styles from './forms.module.scss'
import { submitToNetlify } from './helpers'
import { trackEvent, getUtmData, pageName } from '../../utils'

const formName = 'DemoRequest'
const formProps = [
  'email',
  'fullName',
  'companyName',
  'phoneNumber',
  'ats',
  'teamSize',
  'utmSource',
  'utmCampaign',
  'utmMedium',
  'pageName',
  'source',
]
const initialState = {
  email: '',
  fullName: '',
  companyName: '',
  phoneNumber: '',
  ats: '',
  teamSize: '',
  source: '',
  utmSource: '',
  utmCampaign: '',
  utmMedium: '',
  invalidFields: [],
  error: null,
  success: null,
  loading: false,
  hasEdited: false,
}

class ContactForm extends Component {
  constructor(props) {
    super(props)
    this.invalid = this.invalid.bind(this)
    this.update = this.update.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.state = {
      ...initialState,
    }
  }

  componentDidMount() {
    const { cookies } = this.props
    const utmData = getUtmData(cookies)
    this.setState({
      ...utmData,
      pageName: pageName(),
    })
    console.warn(utmData)
    trackEvent('Demo Request Form Visited', utmData)
  }

  componentWillUnmount() {
    const { hasEdited } = this.state
    if (hasEdited) {
      trackEvent('Demo Request Form Exited Before Completing', {
        ..._.pick(this.state, formProps),
      })
    }
  }

  onChange(obj) {
    this.setState({ ...obj, hasEdited: true, error: false })
  }

  onSubmit(e) {
    e.preventDefault()
    if (this.invalid()) {
      this.setState({
        error: 'Please finish the form before submitting. 🙏',
      })
      return
    }

    this.setState({ loading: true })

    // use form props to track user with Segment
    const { email } = this.state
    const { submitCallback } = this.props

    const data = _.pick(this.state, formProps)

    submitToNetlify(
      {
        data,
        formName,
      },
      error => {
        if (error) {
          console.error(error)
          trackEvent('Demo Request Form Error', { email, error })
          return this.setState({
            error: 'Unable to submit. Please contact us for help!',
            loading: false,
          })
        }
        trackEvent('Demo Request Form Submitted', data)
        this.setState({ ...initialState, success: true })
        if (submitCallback) {
          submitCallback(data)
        }
      }
    )
  }

  invalid() {
    const {
      email,
      fullName,
      companyName,
      phoneNumber,
      ats,
      teamSize,
    } = this.state
    const { shortForm } = this.props
    if (!email || !fullName || !companyName || !phoneNumber) return true
    if (shortForm) return false
    if (!ats || !teamSize) return true
    return false
  }

  update(e) {
    const { name, value } = e.target
    this.setState({ [name]: value })
  }

  render() {
    const {
      atsOptions,
      sizeOptions,
      sourceOptions,
      cta,
      shortForm,
      successText,
    } = this.props
    const {
      email,
      fullName,
      companyName,
      phoneNumber,
      ats,
      teamSize,
      utmSource,
      utmCampaign,
      utmMedium,
      invalidFields,
      error,
      success,
      loading,
      source,
    } = this.state

    const errorMsg = !success && (error || this.invalid())

    return (
      <form
        name={formName}
        method="post"
        data-netlify="true"
        data-netlify-honeypot="bot-field"
        style={{ minWidth: '400px' }}
      >
        <input type="hidden" name="form-name" value={formName} />
        <input type="hidden" name="utmSource" value={utmSource} />
        <input type="hidden" name="utmCampaign" value={utmCampaign} />
        <input type="hidden" name="utmMedium" value={utmMedium} />
        <input type="hidden" name="pageName" value={pageName()} />

        <div className={cx('px-2', 'w-100')}>
          <Input
            className={cx('w-100')}
            value={fullName}
            name="fullName"
            autocomplete="name"
            onChange={this.onChange}
            hideErrorState={!error}
          />
        </div>
        <div
          className={cx(
            'px-2',
            ...(shortForm ? ['w-100'] : ['d-inline-block', 'w-100'])
          )}
        >
          <Input
            className={cx('w-100')}
            type="email"
            value={email}
            name="email"
            placeholder="Work Email"
            autocomplete="email"
            onChange={this.onChange}
            hideErrorState={!error}
          />
        </div>
        <div
          className={cx(
            'px-2',
            ...(shortForm ? ['w-100'] : ['d-inline-block', 'w-50'])
          )}
        >
          <Input
            className={cx('w-100')}
            value={companyName}
            name="companyName"
            autocomplete="organization"
            onChange={this.onChange}
            hideErrorState={!error}
          />
        </div>
        <div className={cx('d-inline-block', 'w-50', 'px-2')}>
          <Input
            className={cx('w-100')}
            type="tel"
            value={phoneNumber}
            name="phoneNumber"
            autocomplete="tel-national"
            onChange={this.onChange}
            hideErrorState={!error}
          />
        </div>

        {!shortForm && (
          <div className={cx('d-inline-block', 'w-50', 'p-2', 'my-2')}>
            <select
              className={cx('w-100', {
                error: invalidFields.includes('ats'),
                placeholder: !ats.length,
              })}
              value={ats}
              name="ats"
              onChange={this.update}
              hideErrorState={!error}
            >
              <option className="placeholder" value="">
                What ATS do you use?
              </option>
              {atsOptions.map(({ option }) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>
        )}

        {!shortForm && (
          <div className={cx('d-inline-block', 'w-50', 'p-2', 'my-2')}>
            <select
              className={cx('w-100', {
                error: invalidFields.includes('teamSize'),
                placeholder: !teamSize.length,
              })}
              value={teamSize}
              name="teamSize"
              onChange={this.update}
            >
              <option className="placeholder" value="">
                Recruiting team size
              </option>
              {sizeOptions.map(({ option }) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>
        )}

        {!shortForm && (
          <div className={cx('d-inline-block', 'w-50', 'p-2', 'my-2')}>
            <select
              className={cx('w-100', {
                error: invalidFields.includes('source'),
                placeholder: !source.length,
              })}
              value={source}
              name="source"
              onChange={this.update}
            >
              <option className="placeholder" value="">
                {' '}
                How did you hear about us?
              </option>
              {sourceOptions.map(({ option }) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>
        )}

        <div className={cx(styles.submitWrap)}>
          <button
            onClick={this.onSubmit}
            className={cx('btn', 'btn-md', 'w-100', 'my-2', {
              disabled: errorMsg,
              'btn-green': success,
              loading,
            })}
            type="submit"
            alt={error || 'Submit form'}
          >
            {success ? successText : cta}
          </button>

          <p className={cx(styles.errorText, { [styles.hide]: !error })}>
            {errorMsg}&nbsp;
          </p>
        </div>
      </form>
    )
  }
}

ContactForm.propTypes = {
  sizeOptions: PropTypes.arrayOf(
    PropTypes.shape({
      option: PropTypes.string,
    })
  ),
  atsOptions: PropTypes.arrayOf(
    PropTypes.shape({
      option: PropTypes.string,
    })
  ),
  sourceOptions: PropTypes.arrayOf(
    PropTypes.shape({
      option: PropTypes.string,
    })
  ),
  cookies: PropTypes.instanceOf(Cookies).isRequired,
  cta: PropTypes.string.isRequired,
  shortForm: PropTypes.bool,
  submitCallback: PropTypes.func,
  successText: PropTypes.string,
}

ContactForm.defaultProps = {
  sizeOptions: [],
  atsOptions: [],
  sourceOptions: [],
  shortForm: false,
  submitCallback: undefined,
  successText: 'Form submitted successfully!',
}

export default withCookies(ContactForm)
